// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3NH-j","sendOtp":"AuthorizeToLogin_sendOtp__M3TUI"};